import React from 'react';
import { Card, Flex, Skeleton } from 'antd';

interface BasicInformationSkeletonProps {
  isMobile?: boolean;
}

/** Loading placeholder for BasicInformation — mirrors the header + two-column field layout. */
export const BasicInformationSkeleton: React.FC<BasicInformationSkeletonProps> = ({
  isMobile = false,
}) => {
  const renderColumn = (rows: number) => (
    <Flex vertical gap={24} style={{ flex: 1, minWidth: 0 }}>
      {Array(rows)
        .fill(0)
        .map((_, i) => (
          <Flex key={i} gap={16} align="center" style={{ height: '24px' }}>
            <Skeleton.Input active size="small" style={{ width: 100, height: 14, minWidth: 100 }} />
            <Skeleton.Input active size="small" style={{ width: '60%', height: 14 }} />
          </Flex>
        ))}
    </Flex>
  );

  return (
    <Card
      style={{
        backgroundColor: 'var(--silia-bg-container)',
        border: '1px solid var(--silia-split)',
        borderRadius: 'var(--silia-radius-xs)',
      }}
      bodyStyle={{ display: 'flex', flexDirection: 'column' }}
    >
      {/* Header (title + description) */}
      <Flex justify="space-between" align="flex-start" gap={16}>
        <Flex vertical gap={6}>
          <Skeleton.Input active size="small" style={{ width: 130, height: 16 }} />
          <Skeleton.Input active size="small" style={{ width: 260, height: 12 }} />
        </Flex>
        <Skeleton.Button active style={{ width: 72, height: 32 }} />
      </Flex>

      {/* Two-column fields */}
      <Flex gap={isMobile ? 24 : 48} vertical={isMobile} style={{ marginTop: '16px' }}>
        {renderColumn(4)}
        {renderColumn(3)}
      </Flex>
    </Card>
  );
};
